import React from 'react';

import { Switch, Route } from 'react-router-dom';

import TicketTable from './table.js'


export default (props) => {
    return(
        <Switch>
            <Route exact path='/ComprasEspeciales' component={TicketTable} />
        </Switch>
    )
}





// WEBPACK FOOTER //
// ./src/views/comprasespeciales/index.js